var map = {
	"./adSet.svg": 97701,
	"./asSetActive.svg": 81520,
	"./catalogue.svg": 14973,
	"./catalogueActive.svg": 16202,
	"./creareActive.svg": 27979,
	"./create.svg": 31406,
	"./document.svg": 1290,
	"./documentAcive.svg": 12699,
	"./search.svg": 42042,
	"./video.svg": 15766,
	"./warning.svg": 73979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;